import React from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from 'src/styles/GlobalStyle';

interface ApplicationInterface {
  children: any;
}

export default function Application({ children }: ApplicationInterface) {
  return (
    <ThemeProvider theme={{}}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
}
